import { render } from "./ModalHeader.vue?vue&type=template&id=2e7863a6&scoped=true"
import script from "./ModalHeader.vue?vue&type=script&lang=js"
export * from "./ModalHeader.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2e7863a6"

export default script